module.exports = __webpack_public_path__ + "img/19.a6710c44.png";